//Please add the language resource
const home = {

  msg:{
  }
};
export default home


// WEBPACK FOOTER //
// ./src/page/home/lang/home.en.js